// extracted by mini-css-extract-plugin
export default {"commentsContainer":"TqMENe"};